import { useFragment } from "@apollo/client";
import UserProfilePictureFragmentFragmentDoc from "src/api/graphql/__generated__/documents/UserProfilePictureFragmentFragmentDoc";
import { useGatheringStore } from "src/contexts/GatheringContext";

const useFilterDisplayState = () => {
	const filterUserIds = useGatheringStore((state) => state.filterUserIds);
	const selectedUserId = filterUserIds?.[0];

	const { data: selectedUser } = useFragment({
		fragment: UserProfilePictureFragmentFragmentDoc,
		from: {
			__typename: "User",
			userId: selectedUserId ?? "",
		},
	});

	const url = selectedUser?.profilePicture?.url;

	return {
		url,
		selectedUserId,
	};
};
export default useFilterDisplayState;
